export const Colors = {
  GRAY: 'text-gray-400 dark:text-gray-500',
  INDIGO: 'bg-indigo-600 hover:bg-indigo-500',
  TEXT_INDIGO: 'text-indigo-600 hover:text-indigo-500',
  PRIMARY: 'bg-sky-500 hover:bg-sky-600',
  CYAN: 'text-cyan-600 dark:text-cyan-500',
};
